const fakeDataForHotel = [
    {
        img: "Rectangle 26.png",
        title: "Light bright airy stylish apt & safe peaceful stay",
        facilities: "Wifi Air Conditioning kitchen",
        fexibility: "Cancellation fexibility availiable",
        rating: "4.9(20)",
        price: "$34/night"

    },
    {
        img: "Rectangle 27.png",
        title: "Apartment in Lost Panorama",
        facilities: "Wifi Air Conditioning kitchen",
        fexibility: "Cancellation fexibility availiable",
        rating: "4.8(10)",
        price: "$52/night"
    },
    {
        img: "Rectangle 28.png",
        title: "AR Lounge & Pool",
        facilities: "Wifi Air Conditioning kitchen",
        fexibility: "Cancellation fexibility availiable",
        rating: "4.9(25)",
        price: "$50/night"
    }
]
export default fakeDataForHotel;